import Vue from 'vue'
export const isLoading = state => state.isLoading
export const userDataItems = state => state.userDataItems
export const itemBrandsItems = state => state.itemBrandsItems
export const itemTypesItems = state => state.itemTypesItems
export const itemCategoriesItems = state => state.itemCategoriesItems
export const priceGroupsItems = (state) => {
  let array = [{ text: Vue.prototype.$lang.t('global.notSet'), value: null }]
  state.priceGroupsItems.forEach(entry => {
    array.push({ text: entry.name, value: entry['@id'] })
  })
  return array
}
export const measuresItems = state => state.measuresItems
export const vatRatesItems = state => state.vatRatesItems
export const casesItems = state => state.casesItems
